<nz-layout class="layout">
  <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" nzBreakpoint="md" [nzCollapsedWidth]="0" [nzTrigger]="null" nzWidth="250px">
    <app-sidebar [(isCollapsed)]="isCollapsed"></app-sidebar>
  </nz-sider>
  <nz-layout [class]="isCollapsed? 'right-layout-min': 'right-layout-full'">
    <app-header [(isCollapsed)]="isCollapsed"></app-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <nz-footer>
      <app-footer></app-footer>
    </nz-footer>
  </nz-layout>
</nz-layout>
